import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Monitor your current balance of NEAR and review recent transactions. ")
const _hoisted_2 = {
  href: "https://wallet.near.org/",
  target: "_blank",
  rel: "noreferrer",
  class: "text-sm font-medium underline text-purple-700 dark:text-purple-400 hover:text-purple-500 dark:hover:text-purple-300 inline-flex items-center whitespace-nowrap"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Open wallet", -1)
const _hoisted_4 = { class: "text-2xl font-bold flex py-1" }
const _hoisted_5 = { class: "truncate" }
const _hoisted_6 = {
  key: 0,
  class: "text-green-500 font-bold"
}
const _hoisted_7 = {
  key: 1,
  class: "text-red-500 font-bold"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "From"),
    /*#__PURE__*/_createElementVNode("th", null, "To"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Date")
  ])
], -1)
const _hoisted_9 = {
  class: "truncate",
  style: {"max-width":"200px"}
}
const _hoisted_10 = {
  class: "truncate",
  style: {"max-width":"200px"}
}
const _hoisted_11 = {
  key: 0,
  class: "text-green-500 font-bold"
}
const _hoisted_12 = {
  key: 1,
  class: "text-red-500 font-bold"
}
const _hoisted_13 = { class: "italic" }
const _hoisted_14 = ["href"]
const _hoisted_15 = ["datetime"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_external_link_icon = _resolveComponent("external-link-icon")!
  const _component_near_symbol = _resolveComponent("near-symbol")!
  const _component_account_link = _resolveComponent("account-link")!
  const _component_HeaderListButtonTemplate = _resolveComponent("HeaderListButtonTemplate")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_DashboardCard = _resolveComponent("DashboardCard")!

  return (_openBlock(), _createBlock(_component_DashboardCard, {
    title: "Balance",
    embed: "embed:balance"
  }, {
    help: _withCtx(() => [
      _hoisted_1
    ]),
    action: _withCtx(() => [
      _createElementVNode("a", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_external_link_icon, { class: "ml-1 text-gray-400" })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_HeaderListButtonTemplate, {
        listTitle: "Recent transfers",
        buttonText: "View transfers",
        empty: _ctx.transfers.length === 0,
        onExpand: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expandModalOpen = true))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_near_symbol, { class: "w-8 h-8" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$filters.number.standard(+_ctx.$filters.toNear(_ctx.view.amount).toString())), 1)
          ])
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transfers.slice(0, 4), (transfer, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_account_link, {
                  account: transfer.account
                }, null, 8, ["account"])
              ]),
              (transfer.incoming)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, " +" + _toDisplayString(_ctx.$filters.number.standard(
                  +_ctx.$filters.toNear(transfer.amount).toString(),
                )), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, " −" + _toDisplayString(_ctx.$filters.number.standard(
                  +_ctx.$filters.toNear(transfer.amount).toString(),
                )), 1))
            ], 64))
          }), 128))
        ]),
        _: 1
      }, 8, ["empty"]),
      _createVNode(_component_Modal, {
        open: _ctx.expandModalOpen,
        title: "Transfers",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expandModalOpen = false)),
        prose: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("table", null, [
            _hoisted_8,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transfers, (transfer, i) => {
                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                  _createElementVNode("td", _hoisted_9, _toDisplayString(transfer.action.signer_account_id), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(transfer.action.receiver_account_id), 1),
                  (transfer.incoming)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_11, " +" + _toDisplayString(_ctx.$filters.number.standard(
                    +_ctx.$filters.toNear(transfer.amount).toString(),
                  )), 1))
                    : (_openBlock(), _createElementBlock("td", _hoisted_12, " −" + _toDisplayString(_ctx.$filters.number.standard(
                    +_ctx.$filters.toNear(transfer.amount).toString(),
                  )), 1)),
                  _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("a", {
                      href: 
                    _ctx.networks[_ctx.network].explorer +
                    '/transactions/' +
                    transfer.action.transaction_hash
                  ,
                      target: "_blank",
                      rel: "noreferrer"
                    }, [
                      _createElementVNode("time", {
                        datetime: 
                      _ctx.$filters.nearTimestampToISO(
                        transfer.action.block_timestamp,
                      )
                    
                      }, _toDisplayString(_ctx.$filters.nearTimestampToLocaleString(
                        transfer.action.block_timestamp,
                        _ctx.DateTime.DATETIME_MED,
                      )), 9, _hoisted_15)
                    ], 8, _hoisted_14)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }))
}